// extracted by mini-css-extract-plugin
export var actions = "_sg-4";
export var item = "_sg-1";
export var price = "_sg-3";
export var quantity = "_sg-2";
export var table = "_sg-0";